module.exports = __webpack_public_path__ + "media/images/emblems/Guensberg-blason-c5dd4fbd3a91af08ec65977726aa52ae.png";